(function () {

  /* ==========================
     LANGUE ACTIVE
  ========================== */
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);

  /* ==========================
     TEXTES TXT / PDF
  ========================== */
  const TXT_TXT = {
    fr: {
      title: "Routine personnalisée",
      machine: "Machine",
      rule: "Règle appliquée",
      cycle1: "Cycle 1 – Lavage coton ou mixte ≥30 min · 30°C",
      cycle2: "Cycle 2 – Lavage coton ≥1h30 · 40°C",
      swoosh: "⚠️ Swoosh positif : réduire la dose ou ajouter des rinçages",
      water: "Consommation d’eau",
      waterReco: "Consommation d’eau recommandée"
    },

    en: {
      title: "Personalized washing routine",
      machine: "Machine",
      rule: "Applied rule",
      cycle1: "Cycle 1 – Cotton or mixed wash ≥30 min · 30°C",
      cycle2: "Cycle 2 – Cotton wash ≥1h30 · 40°C",
      swoosh: "⚠️ Positive swoosh: reduce dosage or add rinses",
      water: "Water consumption",
      waterReco: "Recommended water consumption"
    },

    de: {
      title: "Personalisierte Waschroutine",
      machine: "Maschine",
      rule: "Angewandte Regel",
      cycle1: "Zyklus 1 – Baumwolle oder Mischwäsche ≥30 Min · 30°C",
      cycle2: "Zyklus 2 – Baumwollwäsche ≥1h30 · 40°C",
      swoosh: "⚠️ Positiver Swoosh-Test: Dosierung senken oder Spülgänge hinzufügen",
      water: "Wasserverbrauch",
      waterReco: "Empfohlener Wasserverbrauch"
    }
  };

  const TTXT = TXT_TXT[lang] || TXT_TXT.fr;

  /* ==========================
     ROOT
  ========================== */

  const root = document.getElementById('mbdcRoutine');
  if (!root) return;

  const $ = (s) => root.querySelector(s);
  let lastResult = null;

  function fmt(n){ return Math.round(Number(n || 0)); }

  /* ==========================
     CALCUL
  ========================== */

  function compute(){

    const capKg = parseFloat($('#mbdc-capKg')?.value || 7);
    let waterText = "";

    if (capKg <= 7) {
      waterText = "50 L pour une machine de 4 à 7 kg";
    } else if (capKg <= 9) {
      waterText = "60 L pour une machine de 7 à 9 kg";
    } else {
      waterText = "70 L pour une machine de 9 à 15 kg";
    }

    const hard  = $('#mbdc-hard')?.value;

    if (!hard){
      $('#mbdc-out').innerHTML = `
        <div class="warn">
          <strong>⚠️ ${TTXT.title}</strong><br>
          ${
            lang === 'en'
              ? 'Please select your water hardness before generating the routine.'
              : lang === 'de'
                ? 'Bitte wählen Sie Ihre Wasserhärte, bevor Sie die Routine erstellen.'
                : 'Veuillez sélectionner la dureté de votre eau avant de générer la routine.'
          }
        </div>
      `;
      return;
    }

    const doseLabel = parseFloat($('#mbdc-doseLabel')?.value || 110);
    const swoosh = $('#mbdc-swooshPos')?.checked || false;

    let adjustedDose = doseLabel;
    let ruleText = "7–10 kg";

    if (capKg < 7){
      adjustedDose -= 30;
      ruleText = "< 7 kg → −30 ml";
    } 
    else if (capKg >= 11 && capKg <= 14){
      adjustedDose *= (7 / 4.5);
      ruleText = "11–14 kg";
    } 
    else if (capKg >= 15){
      adjustedDose *= (8 / 4.5);
      ruleText = "≥ 15 kg";
    }

    const preDose = adjustedDose / 3;
    const mainDose = adjustedDose;

    lastResult = { capKg, ruleText, preDose, mainDose, swoosh };

    $('#mbdc-out').innerHTML = `

      <div class="card">

        <h2>${TTXT.title}</h2>

        <div class="kpis">

          <div class="kpi">
            <div>${TTXT.machine}</div>
            <strong>${fmt(capKg)} kg</strong>
          </div>

          <div class="kpi">
            <div>${TTXT.rule}</div>
            <strong>${ruleText}</strong>
          </div>

          <div class="kpi">
            <div>${TTXT.water}</div>
            <strong>${waterText}</strong>
          </div>

        </div>

        <div class="water-estimate">
          <div class="water-title">${TTXT.waterReco}</div>
          <div class="water-value">${waterText}</div>
        </div>

        <div class="grid-2">

          <div class="cycle-card">
            <div class="cycle-title">${TTXT.cycle1}</div>

            <div class="cycle-meta">
              <span class="cycle-badge">≥ 30 min</span>
              <span class="cycle-badge">30 °C</span>
            </div>

            <div class="cycle-dose">${fmt(preDose)} ml</div>
          </div>

          <div class="cycle-card">
            <div class="cycle-title">${TTXT.cycle2}</div>

            <div class="cycle-meta">
              <span class="cycle-badge">≥ 1h30</span>
              <span class="cycle-badge">40 °C</span>
            </div>

            <div class="cycle-dose">${fmt(mainDose)} ml</div>
          </div>

        </div>

        ${swoosh ? `<p><strong>${TTXT.swoosh}</strong></p>` : ``}

      </div>
    `;

    $('#mbdc-btnPrint').disabled = false;
    $('#mbdc-btnTxt').disabled = false;
  }

  /* ==========================
     PDF
  ========================== */

  function printRoutine(){

    const src = root.querySelector('#mbdc-printArea');
    if (!src) return;

    const w = window.open('', '_blank');
    if (!w) return;

    w.document.open();

    w.document.write(`

<!doctype html>
<html lang="${lang}">
<head>

<meta charset="utf-8">
<title>${TTXT.title}</title>

<style>

body{
  font-family:Arial;
  color:#333;
  padding:20px;
}

h2{
  color:#0f7d80;
}

.card{
  border:1px solid #ddd;
  padding:12px;
  border-radius:10px;
}

</style>

</head>

<body>

${src.innerHTML}

<script>
window.onload=function(){window.print()}
<\/script>

</body>
</html>

    `);

    w.document.close();
  }

  /* ==========================
     TXT EXPORT
  ========================== */

  function downloadTxt(){

    if (!lastResult) return;

    const txt = [
      TTXT.title,
      `${TTXT.machine}: ${fmt(lastResult.capKg)} kg`,
      `${TTXT.rule}: ${lastResult.ruleText}`,
      `${TTXT.cycle1}: ${fmt(lastResult.preDose)} ml`,
      `${TTXT.cycle2}: ${fmt(lastResult.mainDose)} ml`
    ].join('\n');

    const blob = new Blob([txt], {type:'text/plain'});

    const a = document.createElement('a');

    a.href = URL.createObjectURL(blob);
    a.download = `routine-${lang}.txt`;
    a.click();
  }

  /* ==========================
     CONVERTER
  ========================== */

  function initConverter(){

    const gramsEl = root.querySelector('#conv-grams');
    const densityEl = root.querySelector('#conv-density');
    const mlEl = root.querySelector('#conv-ml');

    if (!gramsEl || !densityEl || !mlEl) return;

    const num = (v)=>{
      const n=parseFloat(String(v).replace(',','.'));
      return Number.isFinite(n)?n:0;
    };

    let lock=false;

    function toML(){

      if(lock)return;
      lock=true;

      const g=num(gramsEl.value);
      const d=Math.max(0.01,num(densityEl.value));

      mlEl.value=Math.round((g/d)*10)/10;

      lock=false;
    }

    function toG(){

      if(lock)return;
      lock=true;

      const ml=num(mlEl.value);
      const d=Math.max(0.01,num(densityEl.value));

      gramsEl.value=Math.round((ml*d)*10)/10;

      lock=false;
    }

    gramsEl.addEventListener('input',toML);
    mlEl.addEventListener('input',toG);

    densityEl.addEventListener('input',()=>{

      if(num(gramsEl.value)>0) toML();
      else toG();

    });

    toML();
  }

  /* ==========================
     INIT
  ========================== */

  function init(){

    $('#mbdc-run')?.addEventListener('click',compute);
    $('#mbdc-btnPrint')?.addEventListener('click',printRoutine);
    $('#mbdc-btnTxt')?.addEventListener('click',downloadTxt);

    initConverter();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded',init)
    : init();

})();